let median = null
export const putSelectBuilding = (params) => {
    median = params;
}

export const getSelectBuilding = () => {
    return median;
}